import { Component, Injector, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { hasProgrammedVolet } from './services/rachat-allocation';

@UntilDestroy()
@Component({
  selector: 'rachat-form',
  templateUrl: './rachat-form.component.html',
  styleUrls: ['./rachat-form.component.scss'],
  standalone: false,
})
export class RachatFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  operation: string;
  optionsFiscales: { id: string; label: string }[] = [
    {
      id: 'PRELEVEMENT_LIBERATOIRE',
      label: 'Prélèvement libératoire',
    },
    {
      id: 'IMPOT_SUR_LE_REVENU',
      label: 'Impôt sur le revenu',
    },
  ];
  optionsCasExceptionnels: { id: string; label: string }[] = [
    {
      id: 'EXPIRATION_DROITS_CHOMAGE',
      label:
        'Expiration des droits aux allocations chômage accordées consécutivement à une perte involontaire d’emploi',
    },
    {
      id: 'CESSATION_ACTIVITE_NON_SALARIEE',
      label:
        'Cessation d’activité non salariée à la suite d’un jugement de liquidation judiciaire',
    },
    {
      id: 'INVALIDITE',
      label: 'Invalidité de deuxième ou troisième catégorie',
    },
    {
      id: 'DECES',
      label: 'Décès du conjoint /partenaire de PACS',
    },
    {
      id: 'SURENDETTEMENT',
      label: 'Situation de surendettement',
    },
  ];
  optionsMotifs: { id: string; label: string }[] = [
    {
      id: 'FINANCEMENT_ACHAT_IMMOBILIER',
      label: 'Financement d’un achat immobilier',
    },
    {
      id: 'FINANCEMENT_TRAVAUX',
      label: 'Financement de travaux',
    },
    {
      id: 'REMBOURSEMENT_EMPRUNT',
      label: "Remboursement d'emprunt",
    },
    {
      id: 'DONATION_PRESENT_USAGE',
      label: "Donation / Présent d'usage",
    },
    {
      id: 'IMPOTS',
      label: 'Impôts',
    },
    {
      id: 'ACHAT_MOBILIER',
      label: 'Achat mobilier (véhicule, électroménager...)',
    },
    {
      id: 'CHANGEMENT_SITUATION_MATRIMONIALE',
      label: 'Changement de situation matrimoniale (divorce)',
    },
    {
      id: 'BESOIN_TRESORERIE',
      label: 'Besoin de trésorerie (vacances, voyage, loisirs...)',
    },
    {
      id: 'REMBOURSEMENT_AVANCE',
      label: 'Remboursement d’avance',
    },
  ];
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    const { operation } = pledge || {};
    this.operation = operation;
    this.subscriptionFacade.initForm(this);
  }

  get showRppDates(): boolean {
    return hasProgrammedVolet(this.entity);
  }
  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
